
const getFileFetchObject = state => state.v2.fileFetchConnectionDetails

export const getFinicityConnectUrl = state => getFileFetchObject(state).urls.connect
export const getFinicityConnectFixUrl = state => getFileFetchObject(state).urls.connectFix

export const getFileFetchUiFlags = state => {
  return getFileFetchObject(state).uiFlags
}
